import { commonProposalFormApplicationMapper } from "./commonProposalFormMapper";
import * as lookup from "../../../../static/lookup.json"
import { getAge } from "../../../components/services/helperFunctions"
import {valueParser, fullNameCoverter, policyTermValue, repeatableJsonArrayMapper} from "../../dataLayerMapper"

export function stringPath(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  // console.log(a, "a")
  for (var i = 0, n = a.length; i < n; ++i) {

    var k = a[i];
    // console.log(k, "k")
    if (k in o) {
      // console.log("inside if main")
      o = o[k];
      // console.log("inner o", o)
      if (!o) {
        // console.log("inside inner if")
        return ""
      }
    } else {
      // console.log("inside else")
      return "";
    }
  }
  return o;
}

export function fundValueJson(payload) {
  let fund = []
  let nVestFundValue = []
  let fundJson = lookup['promise4GrowthfundValue']['fundMapping']

  if (!fundJson)
    return fund
    Object.keys(fundJson).forEach(path => {
    if (stringPath(payload, path)) {

      let fundName
      let value
      let allocationPercentage
      fundName = stringPath(payload, path)
      if (fundName) {
        value = fundJson[path].fundName
        allocationPercentage = stringPath(payload, fundJson[path].allocationPath)
        let obj = {
          "fundName": value,
          "allocationPercent": allocationPercentage
        }
        let obj1 = {
          "fundId": value,
          "fundPercent": allocationPercentage
        }
        fund.push(obj)
        nVestFundValue.push(obj1)
      }
    }
    else {
      let value
      let allocationPercentage
      value = fundJson[path].fundName
      allocationPercentage = parseInt("0")
      let obj1 = {
        "fundId": value,
        "fundPercent": allocationPercentage
      }
      nVestFundValue.push(obj1)
    }

  })
  let fundValue = [
    fund,
    nVestFundValue
  ]
  return fundValue
}

export function p4gPlusMapper(payload, journeyId, pageId, sectionId,applicationJSON2 ){
    let pageIndicator = pageId + "." + sectionId 
    if (pageId === "AlphaWealthPlanViewBenefitIllustrationPage" && payload?.hasOwnProperty("AlphaWealthPlanViewBenefitIllustrationPage")){
      const benefitPageObject = payload["AlphaWealthPlanViewBenefitIllustrationPage"]
      if (benefitPageObject?.hasOwnProperty("AlphaWealthPlanCFpersonelDetailsSection") 
        || benefitPageObject?.hasOwnProperty("SectionCommonResidenceAndOccupation")){
        payload["AlphaWealthPlanCalculateFundValuePage"] = {
          ...payload["AlphaWealthPlanViewBenefitIllustrationPage"]
        }
      }
    }
    let laAndProposerSame =  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CFislifetobeAssuredandProposer")
    let emailID
    let mobileNo
    let countryCode
    let proposerfirstName =''
    let proposermiddleName =''
    let proposerlastName =''
    let proposerFullName = ''
    if(laAndProposerSame === "N"){
        emailID = valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "proposerEmail")?.toUpperCase()
        mobileNo = valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "contactNoproposer")
        countryCode =  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "proposerNumber")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPProposalDetailName")).firstName 
        proposermiddleName = fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPProposalDetailName")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPProposalDetailName")).lastName || '.'
        proposerFullName = fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPProposalDetailName")).fullName
    }
    else {
        emailID = valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "email")?.toUpperCase()
        mobileNo = valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "contactNo")
        countryCode =  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "mobileNumber")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).firstName
        proposermiddleName = fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).lastName || '.'
        proposerFullName = fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).fullName
    }
    applicationJSON2['lifeAssuredDetails'] = {
        ...applicationJSON2['lifeAssuredDetails'],
        "fullName": fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).fullName,
        "firstName": fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).firstName,
        "middleName": fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).middleName,
        "lastName": fullNameCoverter(valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CPPersonalDetailName")).lastName || '.',
        "gender": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "gender"),
        "dob": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "dateOfBirth"),
        "emailId": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "email"),
        "isLaAndPropSame": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "CFislifetobeAssuredandProposer"),
        "proofOfIdentity": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "ageIdentityProof") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "ageIdentityProof"),
        "maritalStatus"  : valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "martialStatus"),
        "countryOfBirth": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryofbirth") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth"),
        "citizenship": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship"),
        "nationality": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "nationality"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "contactNo"),
                "countryCode":lookup.phoneCountryCodeDupeMapper[0][valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "mobileNumber")],
                "countryCodeMap": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "mobileNumber"),
                "emailId": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "email")?.toUpperCase(),
            },
            "currentAddress": {
                "country": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAcountry") ? valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "GOPAcountry") :lookup.countryCodeToCountry[0][valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "mobileNumber")],
                "state": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAstate"),
                "pinCode": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPApincode"),
                "cityMap": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GopaCity"),
                "cityDistrict": payload.AlphaWealthPlanCalculateFundValuePage?.AlphaWealthPlanCFpersonelDetailsSection?.GopaCity !== "OTHERS" ? valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GopaCity") :  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "citytextgsp"),
            }
        },
        "employmentDetails": {
            "annualIncome": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "annualIncome"),
            "education": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "educationalQualification"),
            "occupation": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAyouAre"),
            "natureOfOccupation": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAexactNatureOfOccupation"),
            "employerIndustry": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "GOPAnatureOfIndustry") ,
            "staff": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "FlexiCPemployeeOfCanaraHSBC"),
            "staffId": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPemployeeID"),
            "employerName": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPcompanyName"),
            "otherEmployerName": lookup.groupComapny[0][valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation", "CPcompanyName")] || ''
        },
    }

    applicationJSON2['proposerDetails'] = {
        ...applicationJSON2['proposerDetails'],
        // "proposerDetails.payorSameAsLA":  valueParser(payload, "PageGuaranteedSavingsCalculatePremium", "SectionGuaranteedSavingsPersonelDetails", "islifetobeAssuredandProposer"),
        "fullName": proposerFullName,
        "firstName": proposerfirstName,
        "middleName": proposermiddleName,
        "lastName": proposerlastName,
        "proposerDetails.dob": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "propserdateOfBirth"),
        "proposerDetails.gender": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "proposergender"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": mobileNo,
                "countryCode": countryCode,
                "emailId": emailID
            }
        },

        "employmentDetails": {
            "annualIncome":valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "proposerannualIncome"),
            "occupation": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "proposerCommonResidenceAndOccupation", "ProposerYouAre"),
            "natureOfOccupation": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "proposerCommonResidenceAndOccupation", "ProposerExactNatureOfOccupation"),
            "employerIndustry": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "proposerCommonResidenceAndOccupation", "ProposerNatureOfIndustry"),
            "education": "",
        },

    }

    applicationJSON2["productDetails"] = {
        ...applicationJSON2["productDetails"],
        "consentPrivacyWaived": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "privacyPolicy") || false,
        "gstWaiverInd": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "GIAPNreAccount") || "N",
        "policyTerm": policyTermValue(payload?.AlphaWealthPlanCalculateFundValuePage?.AlphaWealthPlanInvestmentDetailsSection?.alphaPT, payload?.AlphaWealthPlanCalculateFundValuePage?.AlphaWealthPlanCFpersonelDetailsSection?.dateOfBirth),
        "ptValue": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaPT"),
        "premiumPaymentTerm": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaPPT"),
        "modeOfPayment": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaPaymentFrequency"),
        "premiumFrequency": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaPaymentFrequency"),
        "planOption":  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaInvestmentPlanOption"),
        "planCoverage":  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaInvestmentPlanOption") ,
        "planName":  valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaInvestmentPlanOption"),
        "installmentPremium": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaInstallmentPremium"),
        "modalPrem": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanInvestmentDetailsSection", "alphaInstallmentPremium"),
        "sumAssured" : valueParser(payload,"AlphaWealthPlanCalculateFundValuePage","AlphaWealthPlanInvestmentDetailsSection","alphaSumAssured"),
        "sso" : valueParser(payload,"AlphaWealthPlanCalculateFundValuePage","AlphaWealthPlanPortfolioManangementSection","optionForSSO"),
        "funds" : fundValueJson(payload)
    }

    applicationJSON2["basicDetails"] = {
        ...applicationJSON2["basicDetails"],
        "referrerName": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "referrerNameGIAP"),
        "referrerId": valueParser(payload, "AlphaWealthPlanCalculateFundValuePage", "AlphaWealthPlanCFpersonelDetailsSection", "referrerIdGIAP"),  
        "emailID" : emailID,
        "mobileNo": mobileNo,
        "countryCode": countryCode 
    }

    applicationJSON2["journeyDetailsDirectKeys"] = {
        ...applicationJSON2["journeyDetailsDirectKeys"],
        "bankDetails": {
            "receivingRefundOrPayments": {
                "firstName":proposerfirstName,
                "middleName":proposermiddleName,
                "lastName":proposerlastName
            }
        }
    }
            
    
    if(pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalInsuranceHistory" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalHealth&LifestyleDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillproposalOccupationDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalMedicalInformation" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNomineeDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.FlexiEdgeFillProposalAppointeeSection" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCovidQuestionnaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeBankDetailsOfProposer" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionOil" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMarine" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMining" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionDefence" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFemaleMedicalQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.reviewDetailsflexiEdge" || 
    pageIndicator === "makePayment.make-Payment" ||
    pageIndicator === "makePayment.successful-transaction" ||
    pageIndicator === "makePayment.unsuccessful-transaction" ||
    pageIndicator === "makePayment.pending-transaction" ||
    pageIndicator === "makePayment.eNach-physicalMandate" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.declaration" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.UploadDocuments" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.application-submission" 
    ){
        applicationJSON2  = commonProposalFormApplicationMapper(payload, journeyId, pageId, sectionId, applicationJSON2)
    }
    return applicationJSON2
}
